import { render, staticRenderFns } from "./checkrobot.vue?vue&type=template&id=39def04e"
import script from "./checkrobot.vue?vue&type=script&lang=js"
export * from "./checkrobot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports